export default __webpack_public_path__ + "static/media/noun_Energy_2965874.b74f4fe1.png";